// src/app/l/[shortCode]/index.tsx

import { type Href, Redirect, useLocalSearchParams } from "expo-router"
import { useAppShortLinkRedirect } from "@/queries/links"
import { ActivityIndicator } from "react-native"
import FullScreenBackgroundGradient from "@/components/backgrounds/FullScreenBackgroundGradient"
import React from "react"

const ShortCodeRedirect = () => {
  const { shortCode } = useLocalSearchParams()
  const { data, error } = useAppShortLinkRedirect(shortCode as string)

  // This value only evaluates truthy if the shortCode resolves to a valid
  // Backflip App URL (meaning the data.type == 'backflip-app')
  // Otherwise you get a GraphQLError
  if (data?.originalUrl) {
    return <Redirect href={data.originalUrl as Href} />
  }

  // Just redirect to home for now if there's an error
  if (error) {
    return <Redirect href="/" />
  }

  // Show the spinner while the query is loading
  return (
    <>
      <FullScreenBackgroundGradient />
      <ActivityIndicator
        className="flex-1 justify-center items-center pt-10"
        size={"small"}
      />
    </>
  )
}

export default ShortCodeRedirect
